import React, { useEffect, useState, useContext } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";
import {
  ThemeProvider,
  createMuiTheme,
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import { State } from "../store/state";
import { dismissAlert, getCharities } from "../store/actions";
import Alert from "./alert";
import Progress from "./progress";
import SearchResults from "./searchResults";

const App = (props) => {
  const generateClassName = createGenerateClassName({
    seed: "tbcategory",
  });

  const theme = createMuiTheme(props.theme);
  const useStyles = makeStyles((theme) => ({
    main: { paddingTop: theme.spacing(2) },
  }));
  const classes = useStyles();
  const { state, dispatch } = useContext(State);

  useEffect(() => {
    if (props.categoryID) {
      getCharities(props.categoryID, dispatch);
    }
  }, []);

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <ScopedCssBaseline className={classes.main}>
          {state.alerts.length > 0 && (
            <Alert
              alert={state.alerts[0]}
              onDismiss={() => {
                dismissAlert(dispatch);
              }}
            />
          )}
          <Progress busy={state.busy} />
          {!state.busy && (
            <SearchResults
              charities={state.charities}
              categoryID={props.categoryID}
            />
          )}
        </ScopedCssBaseline>
      </ThemeProvider>
    </StylesProvider>
  );
};
export default App;
